import _ from 'lodash'

import { NoveltyRule } from '@/models/api/campaign/noveltyCampaign'
import { Novelty } from '@/models/novelty/novelty'
import { NoveltySelection } from './novelty-selection'
import { SkuSummary } from './sku-summary'

export class FkuSummary {
  constructor(
    public rule: NoveltyRule,
    public novelties: Novelty[],
    public selectedNovelties: NoveltySelection[],
    private cartPrice: number
    ) {
  }

  get totalCount(): number {
    return _.sum(this.selectedNovelties.map(s => s.count))
  }

  get maxCount(): number {
    return this.rule.select_limit
  }

  get allSkuSummaries(): SkuSummary[] {
    return _.compact(
      this.novelties.map((novelty) => {
        const selection = this.selectedNovelties.find(s => s.skuId === novelty.skuId)

        if (!selection) {
          // Skip, for no selection data is made for novelty.
          return
        }

        return new SkuSummary(this.rule, novelty, selection, this.cartPrice)
      })
    )
  }

  get userCanChangeCount(): boolean {
    return this.allSkuSummaries.some(summary => summary.userCanChangeCount)
  }
}
